import { Eye, Forward, Star, Verified } from '../../assets/icons';
import NoImage from '../../assets/icons/no-image.svg';
import OfferImg from '../../assets/img/offer.png';
import { useNavigate } from 'react-router-dom';
import { TagCard } from './tag-card';
import { useState, useRef, useEffect } from 'react';
import { getImageUrl } from '../../helpers/img-resolve';

export const ServiceCard = ({service}) => {
  const navigate = useNavigate();

  const [hasOverflow, setHasOverflow] = useState(false);
  const containerRef = useRef(null);

  const categories = service?.categories?.map((category) => ({name: category.name, img: getImageUrl('img',category.iconName)})) ?? []
  // Duplicate the categories by concatenating with itself

  // // Check for overflow
  // useEffect(() => {
  //   const checkOverflow = () => {
  //     if (containerRef.current ) {
  //       const element = containerRef.current;
  //       setHasOverflow(element.scrollHeight > element.clientHeight);
  //     }
  //   };
  //
  //   checkOverflow();
  //   window.addEventListener('resize', checkOverflow);
  //   return () => window.removeEventListener('resize', checkOverflow);
  // }, [categories]);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const handleCardClick = () => {
    navigate(`/service/${service.serviceId}`);
  };

  const hasMedia = Boolean(service?.logoUrl)
  const logoUrl = hasMedia ? getImageUrl('img',service.logoUrl) : NoImage;

  return (
    <div className="w-full sm:w-[288px] bg-white rounded-2xl shadow-lg overflow-hidden transition-transform duration-300 sm:hover:scale-105 sm:hover:shadow-2xl sm:hover:cursor-pointer"
    onClick={handleCardClick}
    >
      {/* Header */}
      <div className="p-2 pb-2 h-[90px]">
        <div className="flex items-center gap-1">
          { service.verified && <>
            <div className="w-6 h-6 rounded-lg flex items-center justify-center">
              <Verified/>
            </div>

            <div className={'flex bg-blue-50 rounded-lg p-1'}>
              <span className="text-blue-500 font-semibold text-sm">VERIFICAT</span>
            </div>
          </>
          }
          <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
          <span className="font-bold text-gray-500">{service.rating}</span>

          <div className="text-sm flex items-center gap-1 py-1 rounded-lg ml-auto text-gray-500">
            <Eye className="w-5 h-5" />
            {service.views}
          </div>
        </div>

        <h2 className="font-manrope font-semibold leading-[22.4px] color-#1D2126 text-[16px]">
          {service.name}
        </h2>
      </div>

      {/* Main Image Section */}
      <div className="h-[166px] relative">
        <img
          src={logoUrl}
          alt="Mechanic working on hybrid car"
          className="w-full h-full object-cover"
        />

        { service.offers && (
          <div className="absolute top-0 right-0 flex items-center">
            <div className="relative top-1 left-2">
              <img src={OfferImg} className="h-[35px] w-[35px]"/>
            </div>

            <div className="bg-[#FF9700] text-white px-2 py-0.5 mt-3 text-sm font-bold tracking-wide">
              PROMOȚII
            </div>
          </div>)
        }
      </div>

      {/* Services Tags */}
      <div className="px-2 py-2">
        <div
          ref={containerRef}
          className={'flex flex-wrap gap-1 relative transition-all duration-300 h-[68px] overflow-hidden mt-1 max-w-full'}
          style={{
            maxHeight: '68px',
            WebkitMaskImage: hasOverflow ? 'linear-gradient(to right, black 80%, transparent 100%)' : 'none'
          }}
        >
          {categories.map((category, index) => (
            <TagCard key={index} tag={category} className={'h-6 w-6'}/>
          ))}

          {/* Gradient overlay and ellipsis when content overflows */}
          {hasOverflow && (
            <>
              <div className="absolute bottom-0 right-0 w-20 h-full bg-gradient-to-l from-white to-transparent pointer-events-none" />
              <div className="absolute bottom-1 right-3 text-lg font-bold">...</div>
            </>
          )}
        </div>


        <div className="border-t-2 border-gray-200 mt-3"></div>
        {/* Footer Button */}
        <div>
          <button className="w-full flex items-center justify-center text-blue-500 mt-1 mb-1 font-semibold text-sm" onClick={handleCardClick}>
            Detalii
            <Forward className="ml-1"/>
          </button>
        </div>
      </div>
    </div>
  )
}